var React = require('react');

function Liked (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Artboard 3"),React.createElement("path",{"d":"M38.42,39.59,45.48,8.86A5.66,5.66,0,0,1,56.63,7.61l2,24.82a1.58,1.58,0,0,0,1.92,1.42l29.11-6.33a7.32,7.32,0,0,1,8.7,5.18A7.13,7.13,0,0,1,93,41.38l-.26.06a7.16,7.16,0,0,1,3.5,5.36,7.3,7.3,0,0,1-5.79,7.8h0A7.16,7.16,0,0,1,93.88,60a7.31,7.31,0,0,1-5.78,7.81h0a7.16,7.16,0,0,1,3.5,5.36,7.3,7.3,0,0,1-5.79,7.81l-3.23.7L63.47,86a43.82,43.82,0,0,1-20.07-.11L44,88.45a4.48,4.48,0,0,1-3.43,5.33l-18,3.92-1.9-8.76,13.64-3L26.12,48.61l-13.64,3-1.9-8.76,18-3.92a4.48,4.48,0,0,1,5.33,3.43l.72,3.3A11,11,0,0,0,38.42,39.59ZM19.25,82.33a5,5,0,1,0-2.44-6.61A5,5,0,0,0,19.25,82.33Zm-1-48.81a1.55,1.55,0,0,0,2.19,0L34.29,19.69A10.17,10.17,0,1,0,19.91,5.3l-.56.56-.57-.57A10.16,10.16,0,1,0,4.41,19.67Z","key":1})]);
}

Liked.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 100 125","x":"0px","y":"0px"};

module.exports = Liked;

Liked.default = Liked;
